import * as d3 from "d3";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { XAxis } from "./XAxis";
import { YAxis } from "./YAxis";
import moment from "moment";

import "./Stress.css";

function Stress({
  heartRateBars,
  sdnnBars,
  sdnnStats,
  isRealtime,
  fill = "#404392",
}) {
  const width = 900;
  const height = 100;
  const [marginLeft, marginRight, marginTop, marginBottom] = [25, 15, 15, 15];
  const innerWidth = width - marginLeft - marginRight;
  const innerHeight = height - marginTop - marginBottom;

  const xScale = useMemo(() => {
    let min = d3.min(heartRateBars, (d) => new Date(d.timepoint));
    let max = d3.max(heartRateBars, (d) => new Date(d.timepoint));

    if (isRealtime) {
      max = moment(max).endOf("hour").toDate();
      min = moment(min).startOf("hour").toDate();
    }

    return d3
      .scaleTime()
      .domain([min, max])
      .range([marginLeft + 3, innerWidth]);
  }, [heartRateBars, innerWidth, marginLeft]);

  const yScale = useMemo(() => {
    const min = d3.min(heartRateBars, (d) => d.min);
    const max = d3.max(heartRateBars, (d) => d.max);
    return d3
      .scaleLinear()
      .domain([min, max])
      .range([innerHeight, marginBottom]);
  }, [heartRateBars, innerHeight, marginBottom]);

  // const averageLine = d3
  //   .line()
  //   .x((d) => xScale(new Date(d.timepoint))+ 2)
  //   .y((d) => yScale(d.median))(heartRateBars);

  return (
    <>
      {heartRateBars && (
        <div className="Stress_chart">
          <div className="Stress_chart__Chart">
            <svg className="Sparkline" viewBox={`0 0 ${width} ${height}`}>
              <g>
                <XAxis
                  xScale={xScale}
                  innerHeight={innerHeight + marginBottom - 5}
                ></XAxis>
                <YAxis
                  margin={marginLeft}
                  yScale={yScale}
                  innerWidth={innerWidth}
                  ticks={5}
                ></YAxis>
              </g>

              <g>
                {heartRateBars.map((d, i) => (
                  <g>
                    <rect
                      className="Stress__bar"
                      x={xScale(new Date(d.timepoint))}
                      value={d.timepoint}
                      y={yScale(d.max)}
                      height={-yScale(d.max) + yScale(d.min)}
                      width={Math.min(
                        6,
                        Math.abs(innerWidth / heartRateBars.length - 1.5)
                      )}
                      key={`rect-${d.timepoint}`}
                      fill={fill}
                    ></rect>
                    <circle
                      cx={
                        xScale(new Date(d.timepoint)) +
                        Math.min(
                          6,
                          Math.abs(innerWidth / heartRateBars.length - 1.5)
                        ) /
                          2
                      }
                      cy={yScale(d.median)}
                      r="1"
                      fill="rgba(255,255,255, 1)"
                      stroke="white"
                      strokeWidth={"0px"}
                    ></circle>
                  </g>
                ))}
              </g>
              {/* <path
                style={{ stroke: "rgba(36, 38, 90, 1)", strokeWidth: "2px" }}
                className="line-chart__line"
                id={`line-hrv`}
                d={averageLine}
              /> */}
            </svg>
          </div>
        </div>
      )}
    </>
  );
}

export default observer(Stress);
